module.exports = __webpack_public_path__ + "img/trezor.557b3fd1.png";